// extracted by mini-css-extract-plugin
export default {"footer":"table-footer_footer__Ehl0e"};